<template>
  <div class="rationality-containear common_radius">
    <div class="main-pad">
      <div class="chart-table">
        <div class="chart-box">
          <el-tooltip
            class="item"
            effect="dark"
            :content="'框选'"
            placement="right"
            v-if="isShowChart"
          >
            <el-button
              class="tool-btn"
              type="text"
              :icon="'el-icon-crop'"
              @click="handleToolClick('crop')"
            ></el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="'取消'"
            placement="right"
            v-if="isShowChart"
          >
            <el-button
              class="tool-btn sp"
              type="text"
              :icon="'el-icon-circle-close'"
              @click="handleToolClick('cancel')"
            ></el-button>
          </el-tooltip>

          <Chart
            v-if="isShowChart"
            ref="chart"
            :option="chartOption"
            @datazoom="handleDataZoomChange"
            @brush="handleBrushChange"
          ></Chart>
          <div class="place-text" v-else>
            <span>请勾选通道展示数据</span>
          </div>
        </div>
        <div class="table my-hot">
          <hot-table
            v-if="hasTable"
            :dataSchema="dataSchema"
            tableClassName="my-hot-table-class"
            licenseKey="non-commercial-and-evaluation"
            height="100%"
            :colHeaders="colHeaders"
            :rowHeaders="rowHeaders"
            :readOnly="true"
            :data="data"
            :colWidths="75"
            :rowHeaderWidth="140"
            :contextMenu="contextMenu"
            key="non-commercial-and-evaluation"
            :renderer="renderFn"
            :selectionMode="'range'"
          ></hot-table>
        </div>
      </div>
      <div class="tool-box">
        <div class="init-shuaixuan">
          <!-- <el-button @click="handleInitFilter">初步筛选</el-button> -->
        </div>
        <div class="tab-box">
          <div class="apply-box">
            <span @click="showFilterResult">统计结果</span>
          </div>
          <div class="tab-title">
            <div
              :class="[
                'tab-item',
                {
                  active: activeTab === index
                }
              ]"
              v-for="(item, index) in tabs"
              :key="index"
              @click="handleTabItemClick(index)"
            >
              {{ item.name || '' }}
            </div>
          </div>
          <div class="tab-content" :style="{ maxHeight: minHeight + 'px' }">
            <div class="tab-content-inner">
              <div class="first" v-if="activeTab === 0">
                <div class="first-top">
                  <div
                    class="rule-item"
                    v-for="(item, index) in manuRules"
                    :key="index"
                  >
                    <div
                      class="color-tag"
                      :style="{ backgroundColor: item._color }"
                    ></div>

                    <div class="mr-10">
                      <!-- 为了避免浏览器崩溃暂时注释掉默认通道
                     -->
                      <el-checkbox
                        v-model="item.firstChecked"
                        @change="
                          val => {
                            handleFirstCheckBoxChange(val, item, index);
                          }
                        "
                      ></el-checkbox>
                    </div>
                    <div>
                      <!-- 为了避免浏览器崩溃暂时注释掉默认通道
                     -->
                      <el-checkbox
                        v-model="item.secChecked"
                        @change="
                          val => {
                            handleFirstCheckBoxChange(val, item, index);
                          }
                        "
                      ></el-checkbox>
                    </div>
                    <span class="name">{{ item.name }}</span>
                    <!-- <i class="el-icon-close" @click="handleLabelClick(index)"></i> -->
                  </div>
                </div>
                <!-- <div class="first-bottom">
                  <el-button v-if="isOwnerFlag == 1" @click="handleApplyRule"
                    >应用规则</el-button
                  >
                </div> -->
              </div>
              <div class="last" v-if="activeTab === 1">
                <div class="last-top">
                  <div
                    class="rule-item"
                    v-for="(item, index) in rules"
                    :key="index"
                    @click.stop="handleRuleItemClick(item)"
                  >
                    <el-checkbox
                      @click.stop.native="handleRuleElcheckClick(item)"
                      v-model="item.checked"
                    ></el-checkbox>
                    <span class="name">{{ item.name }}</span>
                    <i
                      class="el-icon-close"
                      @click.stop="handleDelClick(item, index)"
                    ></i>
                  </div>
                </div>
                <div class="plus">
                  <i
                    v-if="isOwnerFlag == 1"
                    class="el-icon-circle-plus-outline"
                    @click="handlePlusClick"
                  ></i>
                </div>
                <div class="last-bottom">
                  <el-button v-if="isOwnerFlag == 1" @click="handleApplyRule"
                    >应用规则</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      v-drag:common
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
      top="20vh"
      :before-close="
        () => {
          handleReset();
        }
      "
    >
      <div class="dialog-content">
        <div class="name">
          <div class="key-name">
            规则名称:
          </div>
          <el-input v-model="ruleForm.ruleName"></el-input>
        </div>
        <div class="logic">
          <div class="key-name"></div>
          <div :style="{ width: '140px', 'margin-right': '15px' }">
            <el-input
              placeholder="步长值"
              v-model.number="ruleForm.stepValue"
            ></el-input>
          </div>
          <div :style="{ width: '100px', 'margin-right': '15px' }">
            <el-select v-model="ruleForm.stepType">
              <el-option
                v-for="(item, index) in stepList"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="logic">
          <div class="key-name">
            判断逻辑:
          </div>
          <div :style="{ width: '140px', 'margin-right': '15px' }">
            <el-select
              v-model="ruleForm.dataRuleId"
              @change="handleDataRuleChange"
            >
              <el-option
                v-for="(item, index) in dataRules"
                :key="index"
                :label="item.dataRuleName"
                :value="item.dataRuleId"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <div :style="{ width: '100px', 'margin-right': '15px' }">
            <el-select v-model="ruleForm.channelType">
              <el-option
                v-for="(item, index) in channelTypes"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->
          <template v-if="isOneChannel">
            <div :style="{ width: '100px', 'margin-right': '15px' }">
              <el-select v-model="channelStore.channelId1">
                <el-option
                  v-for="(item, index) in channels"
                  :key="index"
                  :label="item.channelName"
                  :value="item.channelType + '_' + item.channelId"
                >
                </el-option>
              </el-select>
            </div>
          </template>
          <template v-else>
            <div :style="{ width: '110px' }">
              <el-select v-model="channelStore.channelId1">
                <el-option
                  v-for="(item, index) in channels"
                  :key="index"
                  :label="item.channelName"
                  :value="item.channelType + '_' + item.channelId"
                >
                </el-option>
              </el-select>
            </div>
            <span :style="{ margin: '0px 10px' }"> 与 </span>
            <div :style="{ width: '110px', 'margin-right': '15px' }">
              <el-select v-model="channelStore.channelId2">
                <el-option
                  v-for="(item, index) in channels"
                  :key="index"
                  :label="item.channelName"
                  :value="item.channelType + '_' + item.channelId"
                >
                </el-option>
              </el-select>
            </div>
          </template>
          <div :style="{ width: '140px', 'margin-right': '15px' }">
            <el-select
              v-model="ruleForm.checkRuleId"
              @change="handleCheckRuleChange"
            >
              <el-option
                v-for="(item, index) in checkRules"
                :key="index"
                :label="item.checkRuleName"
                :value="item.checkRuleId"
              >
              </el-option>
            </el-select>
          </div>

          <div class="value-box">
            <template v-if="isOneInput">
              <div :style="{ width: '100px' }">
                <el-input
                  v-model="inputStore.num1"
                  placeholder="数值"
                ></el-input>
              </div>
            </template>
            <template v-else>
              <div :style="{ width: '100px' }">
                <el-input
                  v-model="inputStore.num1"
                  placeholder="数值"
                ></el-input>
              </div>
              <span :style="{ margin: '0px 10px' }">~</span>
              <div :style="{ width: '100px' }">
                <el-input
                  v-model="inputStore.num2"
                  placeholder="数值"
                ></el-input>
              </div>
            </template>
          </div>
        </div>
        <div class="apply-channel">
          <div class="key-name">
            应用通道:
          </div>
          <div class="all-check-channel">
            <div class="checkbox-width">
              <el-checkbox
                :key="index"
                v-for="(item, index) in channelCheckBoxs"
                v-model="item._applyChecked"
              >
                {{ item.channelName }}
              </el-checkbox>
            </div>
          </div>
        </div>
        <div class="apply-channel">
          <div class="key-name">
            标记状态:
          </div>
          <div>
            <el-radio-group v-model="markState">
              <el-radio
                v-for="(item, index) in markList"
                :key="index"
                :label="item.value"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
      </div>
      <div slot="footer" class="wind-stand-footer-container">
        <ct-button
          size="small"
          type="primary"
          v-if="isOwnerFlag == 1"
          :btn-click="addRule"
          >保存</ct-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-if="resultVisible"
      title="统计结果"
      :visible.sync="resultVisible"
      :width="70 * (filterResultTable.length + 1) + 40 + 'px'"
      top="20vh"
      v-drag:common
    >
      <div class="result-table-container">
        <!-- <div class="ll-pad">
          <div class="title">勾选</div>
          <template>
            <div
              :class="{
                even: index % 2 == 0,
                odd: index % 2 == 1
              }"
              v-for="(item, index) in markList"
              :key="index"
            >
              <el-checkbox
                v-if="item.isShow"
                v-model="item.checked"
              ></el-checkbox>
            </div>
          </template>
        </div> -->
        <div class="left-pad">
          <div class="title">
            数据类型
          </div>
          <div class="even">
            正常
          </div>
          <div class="odd">
            无效
          </div>
          <div class="even">
            低质量
          </div>
          <div class="odd">
            塔影
          </div>
          <div class="even">
            结冰
          </div>
        </div>
        <div class="right-pad">
          <div
            class="item"
            v-for="(item, index) in filterResultTable"
            :key="index"
          >
            <div class="item-i title">
              {{ item.channel || 0 }}
            </div>
            <div class="item-i even">
              {{ item.normal || 0 }}
            </div>
            <div class="item-i odd">
              {{ item.abnormal || 0 }}
            </div>
            <div class="item-i even">
              {{ item.lowquality || 0 }}
            </div>
            <div class="item-i odd">
              {{ item.shadow || 0 }}
            </div>
            <div class="item-i even">
              {{ item.frozen || 0 }}
            </div>
          </div>
        </div>
      </div>
      <!--
      <div slot="footer" class="wind-stand-footer-container">
        <ct-button type="primary" size="small" :btn-click="restore"
          >恢复</ct-button
        >
        <ct-button
          size="small"
          :btn-click="
            () => {
              delresult(1);
            }
          "
        >
          删除
        </ct-button>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import Chart from '../components/chart';
import moment from 'moment';
import flatten from 'lodash/flatten';
import { HotTable } from '@handsontable/vue';
import { isInteger } from '@/utils';
// import loadingMask from '@/components/loading-mask';

export default {
  components: {
    Chart,
    HotTable
  },
  data() {
    return {
      ruleCheckboxs: {
        normal: '',
        abnormal: '',
        lowquality: '',
        shadow: '',
        frozen: ''
      },
      channelCheckBoxs: [],
      themeColors: [
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
        '#eedd78',
        '#73a373',
        '#73b9bc',
        '#7289ab',
        '#91ca8c',
        '#f49f42',
        '#ffaf51',
        '#ffee51',
        '#8c6ac4',
        '#715c87',
        '#9b8bba',
        '#e098c7',
        '#8fd3e8',
        '#71669e',
        '#cc70af',
        '#7cb4cc',
        '#fc97af',
        '#87f7cf',
        '#f7f494',
        '#72ccff',
        '#f7c5a0',
        '#d4a4eb',
        '#d2f5a6',
        '#76f2f2'
      ],
      markState: '',
      iskuangxuan: false,

      stepList: [
        {
          name: '步长'
        },
        {
          name: '分钟'
        },
        {
          name: '小时'
        }
      ],

      channelTypes: [
        {
          name: '均值',
          value: 1
        },
        {
          name: '标准差',
          value: 2
        }
      ],
      minHeight: 0,
      dialogTitle: '',
      hasTableFlag: false,
      resultVisible: false,
      tableStartVal: '',
      tableEndVal: '',
      tableHeader: [],
      activeTab: 0,
      dialogVisible: false,
      dataRules: [],
      channels: [],
      checkRules: [],
      ruleForm: {
        // channelType: null,
        ruleName: '规则名称',
        dataRuleId: '',
        checkRuleId: '',
        value: '',
        stepValue: 1,
        stepType: '步长'
      },
      isOneInput: true,
      isOneChannel: true,
      inputStore: {
        num1: '',
        num2: ''
      },
      channelStore: {
        channelId1: '',
        channelId2: ''
      },
      manuRules: [],
      rowHeaders: [],
      colHeaders: [],

      rules: [],
      tabs: [
        {
          name: '人工标记'
        },
        {
          name: '规则标记'
        }
      ],
      filterResultTable: [],
      timer: null,
      date: [],
      chartOption: {},
      chartType: 'candlestick',
      currentStart: 0,
      currentEnd: 100,
      data: [],
      headerArr: [],
      brushStart: null,
      brushEnd: null,
      dataSchema: {},
      hotTableOption: {
        height: 470,
        width: 400
      },
      storeFlag: {},
      timestamp: [],
      markList: [
        {
          name: '正常',
          value: 0,
          checked: false,
          isShow: false
        },
        {
          name: '无效',
          value: 1,
          checked: false,
          isShow: true
        },
        {
          name: '低质量',
          value: 2,
          checked: false,
          isShow: true
        },
        {
          name: '塔影',
          value: 3,
          checked: false,
          isShow: true
        },
        {
          name: '结冰',
          value: 4,
          checked: false,
          isShow: true
        }
      ],
      contextMenu: {
        items: {
          markNormal: {
            name: '标记为正常',
            callback: (key, selection) => {
              this.handleMark(0, selection);
            }
          },
          markInValid: {
            name: '标记为无效',
            callback: (key, selection) => {
              this.handleMark(1, selection);
            }
          },
          markLowQ: {
            name: '标记为低质量',
            callback: (key, selection) => {
              this.handleMark(2, selection);
            }
          },
          markTowerShadow: {
            name: '标记为塔影',
            callback: (key, selection) => {
              this.handleMark(3, selection);
            }
          },
          markFozen: {
            name: '标记为结冰',
            callback: (key, selection) => {
              this.handleMark(4, selection);
            }
          }
        }
      }
    };
  },
  created() {
    this.queryChannels();
    this.queryDataRule();
    this.queryChannelList();
    this.queryTowerRuleList();
  },

  mounted() {
    this.calcBodyHeight();
    window.addEventListener('resize', () => {
      this.calcBodyHeight();
    });
  },
  watch: {
    chartType(val, pre) {
      if (pre === 'line' && val === 'candlestick') {
        this.chartOption = this.getChartOption(this.manuRules);
      }
    },
    selectTowerId(val) {
      if (!val) return;
      this.queryChannels();
      this.queryChannelList();
    },
    SelectVersionId(val) {
      if (!val) return;
      if (this.iskuangxuan) {
        this.$refs.chart.chart.dispatchAction({
          type: 'takeGlobalCursor',
          key: 'brush',
          brushOption: {
            brushType: false,
            brushMode: 'single'
          }
        });

        this.$refs.chart.chart.dispatchAction({
          type: 'brush',
          command: 'clear',
          areas: []
        });
        // this.tableStartVal = this.timestamp[0];
        // this.tableEndVal = this.timestamp[this.timestamp.length - 1];
        // this.queryTableData(true);
        this.hasTableFlag = false;
        this.iskuangxuan = false;
      }
      this.queryTowerRuleList();

      this.data = [];
      this.dataSchema = {};
      // this.manuRules = [];
      this.queryChannels();

      this.currentStart = 0;
      this.currentEnd = 100;
    }
  },

  computed: {
    isOwnerFlag: function() {
      let towerInfo = this.$store.state.WindData.towerObj || {};
      let { isOwnerFlag } = towerInfo;
      return isOwnerFlag;
    },
    hasTable() {
      return this.isShowChart && this.hasTableFlag;
    },
    isShowChart() {
      if (this.manuRules.length) {
        if (
          this.manuRules.some(i => i.firstChecked) ||
          this.manuRules.some(i => i.secChecked)
        ) {
          return true;
        }
      }
      return false;
    },
    selectTowerId() {
      let towerInfo = this.$store.state.WindData.towerObj || {};
      let { towerId } = towerInfo;
      return towerId;
    },
    SelectVersionId() {
      let towerInfo = this.$store.state.WindData.towerObj || {};
      let { versionId } = towerInfo;
      return versionId;
    }
  },
  methods: {
    handleToolClick(type) {
      if (type === 'cancel') {
        this.$refs.chart.chart.dispatchAction({
          type: 'takeGlobalCursor',
          key: 'brush',
          brushOption: {
            brushType: false,
            brushMode: 'single'
          }
        });

        this.$refs.chart.chart.dispatchAction({
          type: 'brush',
          command: 'clear',
          areas: []
        });
        // this.tableStartVal = this.timestamp[0];
        // this.tableEndVal = this.timestamp[this.timestamp.length - 1];
        // this.queryTableData(true);
        this.data = [];
        this.dataSchema = {};
        this.brushStart = null;
        this.brushEnd = null;
        this.hasTableFlag = false;
      } else {
        this.$refs.chart.chart.dispatchAction({
          type: 'takeGlobalCursor',
          key: 'brush',
          brushOption: {
            brushType: 'lineX',
            brushMode: 'single'
          }
        });
      }
      this.iskuangxuan = !this.iskuangxuan;
    },
    restore() {
      this.delresult(0);
    },
    delresult(falg = 1) {
      if (this.markList.every(i => !i.checked)) {
        return this.$message.warning('请选择标记状态');
      }

      this.$confirm(
        `此操作将${falg == 1 ? '删除' : '恢复'}数据, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false
        }
      ).then(() => {
        const state = this.markList
          .filter(i => i.checked)
          .map(i => i.value)
          .join(',');
        this.$fetch('/winddata/dataRuleMark/updateStatisticalResult', {
          showSuccess: true,
          showError: true,
          module: 'windData',
          params: {
            falg: falg,
            state: state,
            versionId: this.SelectVersionId
          }
        }).then(() => {
          this.markList.forEach(i => (i.checked = false));

          this.showFilterResult(true);

          this.mulChannelsClick();
        });
      });
    },
    handleRuleElcheckClick() {},
    showFilterResult(update = false) {
      if (!update) {
        if (this.resultVisible) return;
      }
      this.resultVisible = true;

      this.$fetch('/winddata/dataRuleMark/getStatisticalResult', {
        params: {
          versionId: this.SelectVersionId
        },
        module: 'windData',
        showError: true
      }).then(res => {
        const { data = {} } = res;
        const { tableData = [] } = data;

        this.filterResultTable = tableData;
      });
    },
    judgeGoToQuery(need = false, force = false) {
      if (need) {
        const startIndex = this.currentStart;
        const endIndex = this.currentEnd;

        const length = this.timestamp.length;
        const start = Math.floor((length * startIndex) / 100);
        const end = Math.ceil((length * endIndex) / 100);
        this.tableStartVal = this.timestamp[start];

        this.tableEndVal =
          this.timestamp[end] || this.timestamp[this.timestamp.length - 1];
      }

      this.queryTableData(force);
    },
    calcBodyHeight() {
      this.minHeight = window.innerHeight - 250;
    },
    handleMark(type, selection) {
      if (this.isOwnerFlag == 0) {
        return this.$message.warning('不可标记非自己发布的版本');
      }

      const range = selection[0];
      const { start = {}, end = {} } = range;

      const { row: startRow, col: startCol } = start;
      const { row: endRow, col: endCol } = end;
      const startDate = this.rowHeaders[startRow];
      const endDate = this.rowHeaders[endRow];

      const cols = Object.keys(this.dataSchema);
      let columns = [];
      let i = startCol;

      do {
        columns.push(cols[i]);
        i++;
      } while (i <= endCol);

      const params = {
        state: type,
        endDate,
        startDate,
        versionId: this.SelectVersionId,
        columns: columns.join(',')
      };

      this.$fetch('/winddata/dataRuleMark/signTableData', {
        module: 'windData',
        params,
        showError: true,
        showSuccess: true
      }).then(() => {
        let completeColumns = [];

        columns.forEach(i => {
          const findIndex = this.headerArr.findIndex(header => {
            return header.includes(i);
          });

          this.headerArr[findIndex].forEach(i => {
            completeColumns.push(i);
          });
        });

        completeColumns = Array.from(new Set(completeColumns));

        let i = startRow;
        do {
          completeColumns.forEach(item => {
            try {
              this.data[i][item].state = type;
            } catch (e) {
              //console.log(e);
            }
          });
          i++;
        } while (i <= endRow);

        this.data = [...this.data];

        const channleNos = columns.map(s => {
          return s.replace(/[^0-9]/gi, '');
        });

        // const queryChannles = columns.map(i => {
        //   return (
        //     i.replace(/[^0-9]/gi, '') +
        //     '_' +
        //     (i.replace(/[0-9]/gi, '') === 'avg' ? '1' : '2')
        //   );
        // }); // .join(',');

        let channels = Array.from(new Set(channleNos))
          .map(i => `${i}_1,${i}_2`)
          .map(i => i.split(','));

        channels = flatten(channels);

        const checkedChannels = this.checkedChannels();

        //console.log(1, channels);
        //console.log(2, checkedChannels);

        const finnalChannels = checkedChannels
          .filter(i => channels.includes(i))
          .join(',');

        this.queryErrorData(finnalChannels, true).then(data => {
          data.forEach(i => {
            const { name, errorData } = i;

            const newArr = this.manuRules.map(
              rule => `${rule.channelNo}_${rule.type}`
            );

            const findIndex = newArr.findIndex(a => a == name);

            if (findIndex !== undefined) {
              // this.manuRules[findIndex]._data = data;
              this.manuRules[findIndex]._errorData = errorData;
            }
          });
          this.chartOption = this.getChartOption(this.manuRules);
        });

        // this.queryChartData(queryChannles, true, false).then(data => {
        //   data.forEach(i => {
        //     const { name, data, errorData } = i;

        //     const newArr = this.manuRules.map(
        //       rule => `${rule.channelNo}_${rule.type}`
        //     );

        //     const findIndex = newArr.findIndex(a => a == name);

        //     if (findIndex !== undefined) {
        //       this.manuRules[findIndex]._data = data;
        //       this.manuRules[findIndex]._errorData = errorData;
        //     }
        //   });
        //   this.chartOption = this.getChartOption(this.manuRules);
        // });
      });
    },

    handleInitFilter() {
      this.$fetch('/winddata/dataRuleMark/preliminaryCheck', {
        showError: true,
        showSuccess: true,
        module: 'windData',
        showLoading: {
          mask: true
        },
        params: {
          towerId: this.selectTowerId,
          versionId: this.SelectVersionId
        }
      });
    },

    addRule() {
      if (!this.ruleForm.ruleName) {
        return this.$message.warning('请填写规则名称');
      }

      if (
        !this.ruleForm.stepValue ||
        !/^(\+|-)?\d+($|\.\d+$)/.test(this.ruleForm.stepValue) ||
        !isInteger(this.ruleForm.stepValue)
      ) {
        return this.$message.warning('请填写步长值，步长值需要为整数');
      }

      if (!this.ruleForm.stepType) {
        return this.$message.warning('请选择步长类型');
      }

      if (!this.ruleForm.dataRuleId) {
        return this.$message.warning('请选择数据规则');
      }

      if (!this.ruleForm.checkRuleId) {
        return this.$message.warning('请选择校验规则');
      }

      if (this.isOneChannel) {
        if (!this.channelStore.channelId1)
          return this.$message.warning('请选择通道');
      } else {
        if (!this.channelStore.channelId1 || !this.channelStore.channelId2)
          return this.$message.warning('请选择通道');
      }

      if (this.markState === '') {
        return this.$message.warning('请选择标记通道');
      }

      let value = Object.values(this.inputStore);

      if (this.isOneInput) {
        value = [value[0]];
      }

      const flag = value.some(i => {
        if (i === '') {
          this.$message.warning('数值项不能为空');
          return true;
        }
        if (!/^(\+|-)?\d+($|\.\d+$)/.test(i)) {
          this.$message.warning('数值项请输入数字');
          return true;
        }

        return false;
      });

      const channelIds = Object.values(this.channelStore).filter(i => !!i);
      let nos = [];
      let types = [];
      let ids = [];

      channelIds.forEach(i => {
        const item = i.split('_');
        const slectedItem = this.channels.find(i => i.channelId == item[1]);

        const no = slectedItem.channelNo;
        nos.push(no || '');
        ids.push(item[1]);
        types.push(item[0]);
      });

      if (flag) return;

      const params = {
        applicationChannelNo: this.channelCheckBoxs
          .filter(i => i._applyChecked)
          .map(i => i.channelNo)
          .join(','),
        state: this.markState,
        towerRuleId: this.towerRuleId,
        channelId: ids.join(','),
        channelNo: nos.join(','),
        channelType: types.join(','),
        checkRuleId: this.ruleForm.checkRuleId,
        dataRuleId: this.ruleForm.dataRuleId,
        ruleName: this.ruleForm.ruleName,
        stepValue: this.ruleForm.stepValue,
        stepType: this.ruleForm.stepType,
        value: value.join(','),
        versionId: this.SelectVersionId,
        towerId: this.selectTowerId
      };

      if (!params.applicationChannelNo) {
        return this.$message.warning('请选择应用通道');
      }

      let url = '';
      if (this.dialogTitle.includes('编辑')) {
        url = '/winddata/dataRuleMark/updateTowerRule';
      } else {
        url = '/winddata/dataRuleMark/creatTowerRule';
        delete params.towerRuleId;
      }

      this.$postForm(url, {
        showError: true,
        method: 'post',
        module: 'windData',
        showSuccess: true,
        data: params
      }).then(() => {
        this.handleReset();
        this.dialogVisible = false;
        this.queryTowerRuleList();
      });
    },
    handleReset() {
      this.channels.forEach(i => {
        i._applyChecked = false;
      });
      this.markState = '';
      this.dialogTitle = '';
      this.inputStore = {
        num1: '',
        num2: ''
      };
      this.channelStore = {
        channelId1: '',
        channelId2: ''
      };
      this.ruleForm = {
        ruleName: '规则名称',
        dataRuleId: '',
        checkRuleId: '',
        value: '',
        stepValue: 1,
        stepType: '步长'
        // channelType: null
      };
      this.dialogVisible = false;
    },
    handleCheckRuleChange(val) {
      if ([5, 4].includes(val)) {
        this.isOneInput = false;
      } else {
        this.isOneInput = true;
      }
      this.inputStore = {
        num1: '',
        num2: ''
      };
    },
    handleDataRuleChange(val) {
      this.ruleForm.checkRuleId = '';
      if ([1, 2].includes(val)) {
        this.isOneChannel = true;
      } else {
        this.isOneChannel = false;
      }

      this.queryCheckRules(val);

      this.channelStore = {
        channelId1: '',
        channelId2: ''
      };
    },
    checkNos() {
      const checkedNoList = this.manuRules
        .filter(i => i.firstChecked || i.secChecked)
        .map(i => i.channelNo);

      return Array.from(new Set(checkedNoList));
    },

    checkedChannels() {
      if (!this.manuRules.length) return [];

      const checkedNoList = this.manuRules
        .filter(i => i.firstChecked || i.secChecked)
        .map(item => `${item.channelNo}_${item.type}`);

      return Array.from(new Set(checkedNoList)) || [];
    },

    mulChannelsClick() {
      const channels = this.checkedChannels().join(',');

      if (!channels) return;

      this.queryChartData(channels, true, this.hasTable).then(data => {
        data.forEach(i => {
          const { name, data, errorData, rawData } = i;

          const newArr = this.manuRules.map(
            rule => `${rule.channelNo}_${rule.type}`
          );

          const findIndex = newArr.findIndex(a => a == name);

          if (findIndex !== undefined) {
            this.manuRules[findIndex]._data = data;
            this.manuRules[findIndex]._errorData = errorData;
            this.manuRules[findIndex]._rawData = rawData;
          }
        });
        this.chartOption = this.getChartOption(this.manuRules);
      });
    },

    computeIndexByPercent(arr) {
      const startIndex = this.currentStart;
      const endIndex = this.currentEnd;

      const length = arr.length;
      const start = Math.floor((length * startIndex) / 100);
      const end = Math.ceil((length * endIndex) / 100);
      return { start, end };
    },

    handleFirstCheckBoxChange(val, item, index) {
      const channels = `${item.channelNo}_${item.type}`;
      if (val) {
        this.filterDataSchema();
        if (this.manuRules[index]._data && this.manuRules[index]._errorData) {
          return (this.chartOption = this.getChartOption(this.manuRules));
        }

        this.queryChartData(channels, false, false).then(res => {
          const { data, errorData, rawData } = res;

          if (!this.manuRules[index]._data) {
            this.manuRules[index]._data = data;
            this.manuRules[index]._rawData = rawData;
          }

          if (!this.manuRules[index]._errorData) {
            this.manuRules[index]._errorData = errorData;
          }

          this.chartOption = this.getChartOption(this.manuRules);
        });
      }
      this.filterDataSchema();

      this.$nextTick(() => {
        this.chartOption = this.getChartOption(this.manuRules);
      });
    },

    filterDataSchema() {
      const checkNos = this.checkNos();

      this.colHeaders = flatten(
        this.tableHeader
          .filter(i => checkNos.includes(i.channelNo))
          .map(i => [i.channelName, i.channelName + ' SD'])
      );

      this.headerArr = [];

      const oldHeaders = flatten(
        this.tableHeader
          .filter(i => checkNos.includes(i.channelNo))
          .map(i => {
            const item = ['avg' + i.channelNo, 'stdev' + i.channelNo];
            this.headerArr.push(item);
            return item;
          })
      );

      this.dataSchema = oldHeaders.reduce((acc, c) => {
        acc[c] = null;
        return acc;
      }, {});
    },

    queryTowerRuleList() {
      this.$fetch('/winddata/dataRuleMark/getTowerRuleList', {
        showError: true,
        module: 'windData',
        params: {
          towerId: this.selectTowerId,
          versionId: this.SelectVersionId
        }
      }).then(res => {
        const { data = {} } = res;
        const { checkRuleList = [] } = data;

        this.rules = checkRuleList.map(i => ({
          ...i,
          name: i.ruleName,
          checked: false,
          id: i.towerRuleId
        }));
      });
    },
    queryCheckRules(val) {
      this.$fetch('/winddata/dataRuleMark/getCheckRule', {
        showError: true,
        module: 'windData',
        params: {
          dataRuleId: val
        }
      }).then(res => {
        const { data = {} } = res;
        const { checkRuleList = [] } = data;
        this.checkRules = checkRuleList;
      });
    },
    queryChannelList() {
      this.$fetch('/winddata/dataRuleMark/getChannelList', {
        params: {
          towerId: this.selectTowerId
        },

        showError: true,
        module: 'windData'
      }).then(res => {
        const { data = {} } = res;
        const { channelList = [] } = data;
        this.channels = channelList.map(i => ({
          ...i,
          _applyChecked: false
        }));

        this.channelCheckBoxs = this.channels.filter(i => i.channelType == 1);
      });
    },
    queryDataRule() {
      this.$fetch('/winddata/dataRuleMark/getDataRule', {
        showError: true,
        module: 'windData'
      }).then(res => {
        const { data = {} } = res;
        const { dataRuleList = [] } = data;
        this.dataRules = dataRuleList;
      });
    },
    queryChannels() {
      this.$fetch('/winddata/dataRuleMark/getRationalityChannelList', {
        module: 'windData',
        showError: true,
        params: {
          towerId: this.selectTowerId
        }
      }).then(res => {
        const { data = {} } = res;
        const { channelList = [] } = data;

        this.manuRules = channelList.map((i, index) => ({
          name: i.channelName,
          firstChecked: false,
          secChecked: false,
          // firstChecked: i.defaultSel === 1,
          // secChecked: i.defaultSel === 2,
          _data: null,
          _errorData: null,
          _color: this.themeColors[index % this.themeColors.length],
          ...i
        }));

        // this.mulChannelsClick();
        // this.manuRules.forEach((i, index) => {
        //   this.handleFirstCheckBoxChange(i.firstChecked, i, index);
        //   this.handleFirstCheckBoxChange(i.secChecked, i, index);
        // });
      });
    },
    queryTableData(force = false) {
      if (!force && this.data.length) return;

      if (!this.tableEndVal || !this.tableStartVal) return;

      this.$fetch
        .get('/winddata/dataRuleMark/getRationalityTable', {
          module: 'windData',
          showError: true,
          showLoading: {
            mask: true
          },
          params: {
            startDate: this.tableStartVal,
            endDate: this.tableEndVal,
            towerId: this.selectTowerId,
            versionId: this.SelectVersionId
          }
        })
        .then(res => {
          const { data = {} } = res;
          const { tableData = [], tableHeader = [] } = data;

          this.$nextTick(() => {
            this.filterDataSchema();
          });

          this.tableHeader = tableHeader;

          const headers = [];
          // const arr = Object.keys(item).reduce((acc, c) => {
          //   acc.push(c);
          //   return acc;
          // }, []);
          const realData = [];

          tableData.forEach(i => {
            headers.push(moment(i.timestamp).format('YYYY-MM-DD HH:mm:ss'));

            const item = Object.keys(i.data).reduce((acc, c) => {
              // if (!this.checkedNos.includes(c)) return acc;

              const cur = i.data[c] || {};
              let avgk = 'avg' + c;
              let stdevk = 'stdev' + c;
              acc[avgk] = {
                value: cur.avg,
                state: cur.state
              };

              acc[stdevk] = {
                value: cur.stdev,
                state: cur.state
              };

              return acc;
            }, {});

            realData.push(item);
          });

          this.rowHeaders = headers;
          this.data = realData;
          this.hasTableFlag = true;
        });
    },
    queryErrorData(channels, table) {
      return this.$fetch
        .get('/winddata/dataRuleMark/getRationalityError', {
          module: 'windData',
          showError: true,
          showLoading: true,
          params: {
            channels: channels,
            versionId: this.SelectVersionId
          }
        })
        .then(res => {
          const { data = {} } = res;
          table && this.queryTableData(true);
          const myChannles = channels.split(',');

          const res_1 = myChannles.map(i => {
            const errorKey = i + 'error';
            const errorTimeStamp = i + 'timestamp';

            return {
              name: i,
              errorData: data[errorKey].map((i, index) => {
                return [data[errorTimeStamp][index], i];
              })
            };
          });

          return res_1;
        });
    },
    queryChartData(channels, ismul = false, table = true) {
      return this.$fetch
        .get('/winddata/dataRuleMark/getRationalityChart', {
          module: 'windData',
          showError: true,
          showLoading: true,
          params: {
            channels: channels,
            versionId: this.SelectVersionId
          }
        })
        .then(res => {
          const { data = {} } = res;
          if (!ismul) {
            // let prev = null;
            let a = data[channels];

            // .map(i => {
            //   let index_0 = i[1];
            //   let index_1 = prev === null ? i[1] : prev;

            //   let index_2 = Math.min(index_0, index_1);
            //   let index_3 = Math.max(index_0, index_1);

            //   let res = [index_0, index_1, index_2, index_3];
            //   prev = i[1];
            //   return res;
            // }) || null;
            // this.timestamp = data['timestamp'];

            this.timestamp = data['timestamp'];

            if (this.getInterval(this.currentStart, this.currentEnd) > 100) {
              this.chartType = 'candlestick';
            } else {
              this.chartType = 'line';
            }

            this.tableStartVal = this.timestamp[0];
            this.tableEndVal = this.timestamp[this.timestamp.length - 1];

            const channelError = channels + 'error';
            const timestampError = channels + 'timestamp';
            const errorTimeStamps = data[timestampError];

            let errorData = [];

            if (data[channelError]) {
              errorData = data[channelError].map((i, index) => {
                return [errorTimeStamps[index], i];
              });
            }

            table && this.judgeGoToQuery();
            return {
              rawData: data[channels],
              data: a,
              errorData: errorData
            };
          } else {
            const myChannles = channels.split(',');

            // const errorChannels = myChannles.map(i => i + 'error');
            // const errorTimeStamps = myChannles.map(i => i + 'timestamp');

            this.timestamp = data['timestamp'];

            if (this.getInterval(this.currentStart, this.currentEnd) > 100) {
              this.chartType = 'candlestick';
            } else {
              this.chartType = 'line';
            }
            table && this.judgeGoToQuery(false, true);

            const res = myChannles.map(i => {
              const errorData = [];

              const stamp = i + 'timestamp';

              if (data[stamp]) {
                data[stamp].forEach((item, index) => {
                  errorData[index] = [item, data[i + 'error'][index]];
                });
              }

              // let prev = null;

              return {
                name: i,
                data: data[i],
                rawData: [...data[i]],
                // .map(i => {
                //   let index_0 = i[1];
                //   let index_1 = prev === null ? i[1] : prev;

                //   let index_2 = Math.min(index_0, index_1);
                //   let index_3 = Math.max(index_0, index_1);

                //   let res = [index_0, index_1, index_2, index_3];
                //   prev = i[1];
                //   return res;
                // }) || null,
                errorData: errorData
              };
            });

            return res;
          }
        });
    },
    handleLabelClick() {},
    // eslint-disable-next-line
    renderFn(hotInstance, TD, row, col, prop, value, cellProperties) {
      const { value: _value, state } = value;

      if (+state >= 1) {
        if (state == 1) {
          TD.style.backgroundColor = '#bfbfbf';
        } else if (state == 2) {
          TD.style.backgroundColor = '#08979c';
        } else if (state == 3) {
          TD.style.backgroundColor = '#40a9ff';
        } else if (state == 4) {
          TD.style.backgroundColor = '#2f54eb';
        }
      }

      TD.innerHTML = _value === null ? '' : _value;
    },
    getChartOption(
      data,
      currentStart = this.currentStart,
      currentEnd = this.currentEnd
    ) {
      const isLine = this.chartType === 'line';

      // if (this.brushStart) {
      //   setTimeout(() => {
      //     this.$refs.chart.chart.dispatchAction({
      //       type: 'brush',
      //       areas: [
      //         {
      //           brushType: 'lineX',
      //           coordRange: [
      //             this.timestamp[this.brushStart],
      //             this.timestamp[this.brushEnd]
      //           ],
      //           geoIndex: 0
      //         }
      //       ]
      //     });
      //   }, 2000);
      // }

      let start, end;
      if (isLine) {
        const { start: _start, end: _end } = this.computeIndexByPercent(
          this.timestamp
        );
        start = _start;
        end = _end;
      }

      const firstRules = data
        .filter(i => i.firstChecked)
        .map(i => ({
          sampling: 'average',
          showSymbol: i._rawData && i._rawData.length > 1 ? false : true,
          showAllSymbol: false,
          xAxisIndex: 0,
          yAxisIndex: 0,
          type: this.chartType,
          // symbolSize: 4,
          // symbol: this.chartType === 'line' ? 'none' : 'circle',
          // large: true,
          data: isLine ? i._rawData && i._rawData.slice(start, end) : i._data,
          itemStyle: {
            color: i._color,
            color0: i._color,
            borderColor: i._color,
            borderColor0: i._color,
            borderWidth: 1
          }
        }));

      const firstCheckedErrorData = data
        .filter(i => i.firstChecked)
        .map(i => ({
          xAxisIndex: 0,
          yAxisIndex: 0,
          type: 'scatter',
          // tooltip: {
          //   trigger: 'item',
          //   position: [10, 10]
          // },
          symbolSize: 5,
          symbol: 'circle',
          // large: true,
          data: i._errorData,
          itemStyle: {
            color: '#f5222d'
          }
        }))
        .filter(i => i.data);

      const secRules = data
        .filter(i => i.secChecked)
        .map(i => {
          return {
            showSymbol: i._rawData && i._rawData.length > 1 ? false : true,
            sampling: 'average',
            showAllSymbol: false,
            xAxisIndex: 1,
            yAxisIndex: 1,
            type: this.chartType,
            // symbol: this.chartType === 'line' ? 'none' : 'circle',
            // symbolSize: 4,
            // large: true,
            data: isLine ? i._rawData && i._rawData.slice(start, end) : i._data,
            itemStyle: {
              color: i._color,
              color0: i._color,
              borderColor: i._color,
              borderColor0: i._color,
              borderWidth: 1
            }
          };
        });

      const secCheckedErrorData = data
        .filter(i => i.secChecked)
        .map(i => ({
          xAxisIndex: 1,
          yAxisIndex: 1,
          type: 'scatter',
          symbolSize: 5,
          symbol: 'circle',
          large: true,
          data: i._errorData,
          itemStyle: {
            color: '#f5222d'
          }
        }))
        .filter(i => i.data);

      let grid = [
        {
          y: '7%',
          height: 90,
          top: 20,
          left: 60,
          right: 60
        },
        {
          y2: '7%',
          height: 90,
          top: 130,
          // width: '100%',
          left: 60,
          right: 60
        }
      ];

      if (firstRules.length && !secRules.length) {
        grid = [
          {
            y: '7%',
            height: 200,
            left: 60,
            right: 60
          },
          {
            show: false,
            y2: '7%',
            height: 0,
            top: 100000,
            // width: '100%',
            left: 1000000,
            right: 60
          }
        ];
      }

      if (!firstRules.length && secRules.length) {
        grid = [
          {
            show: false,
            y2: '7%',
            height: 0,
            top: 100000,
            // width: '100%',
            right: 60,
            left: 40
          },
          { y: '7%', height: 200, left: 60, right: 60 }
        ];
      }

      return {
        animation: false,
        textStyle: {
          color: '#222233'
        },
        grid: grid,
        tooltip: {
          trigger: 'item'
        },
        brush: {
          xAxisIndex: 'all',
          brushLink: 'all',
          outOfBrush: {
            colorAlpha: 1
          },
          removeOnClick: false
        },
        toolbox: {
          show: false
          // right: 20,
          // iconStyle: {
          //   color: '#fff'
          // },
          // feature: {
          //   dataZoom: {
          //     show: false
          //   },
          //   brush: {
          //     type: ['clear']
          //   }
          // }
        },
        xAxis: [
          {
            // type: 'time',
            gridIndex: 0,
            scale: true,
            boundaryGap: false,
            // inverse: true,
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#222233'
              }
            },
            splitLine: { show: false },
            // min: 'dataMin',
            // max: 'dataMax',
            data: this.timestamp,
            splitNumber: 20,
            axisLabel: {
              formatter(value) {
                return moment(value).format('YYYY-MM-DD HH:mm');
              },
              textStyle: {
                color: '#222233' //这里用参数代替了
              }
            }
          },
          {
            // type: 'time',
            gridIndex: 1,
            scale: true,
            boundaryGap: false,
            // inverse: true,
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#222233'
              }
            },
            splitLine: { show: false },
            // min: 'dataMin',
            // max: 'dataMax',
            data: this.timestamp,
            splitNumber: 20,
            axisLabel: {
              formatter(value) {
                return moment(value).format('YYYY-MM-DD HH:mm');
              },
              textStyle: {
                color: '#222233' //这里用参数代替了
              }
            }
          }
        ],
        yAxis: [
          {
            scale: false,
            //min: 0,
            // min: 'dataMin',
            // max: 'dataMax',
            gridIndex: 0,
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#222233',
                width: '1'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#222233' //这里用参数代替了
              }
            }
          },
          {
            scale: false,
            //min: 0,
            // min: 'dataMin',
            // max: 'dataMax',
            gridIndex: 1,
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#222233'
              }
            }
          }
        ],
        dataZoom: [
          {
            type: 'inside',
            start: currentStart,
            end: currentEnd,
            xAxisIndex: [0, 1],
            throttle: 500
          },
          {
            throttle: 500,
            type: 'slider',
            zoomLock: true,
            start: currentStart,
            end: currentEnd,
            xAxisIndex: [0, 1],
            textStyle: {
              color: '#222233'
            }
          }
        ],
        series: [
          ...firstRules,
          ...secRules,
          ...firstCheckedErrorData,
          ...secCheckedErrorData
        ]
      };
    },

    getInterval(start, end) {
      const startIndex = start;
      const endIndex = end;

      const length = this.timestamp.length;
      start = Math.floor((length * startIndex) / 100);
      end = Math.ceil((length * endIndex) / 100);

      const startVal = this.timestamp[start];
      const endVal =
        this.timestamp[end] || this.timestamp[this.timestamp.length - 1];
      return moment(endVal).diff(moment(startVal), 'day');
    },

    handleDataZoomChange(params) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        const { batch = [] } = params;

        if (batch.length) {
          const [params = {}] = batch;
          const { start, end } = params;
          if (
            start !== '' &&
            start !== undefined &&
            end !== '' &&
            end !== undefined
          ) {
            // const diff = Math.abs(end - start);
            this.currentStart = start;
            this.currentEnd = end;
            const interval = this.getInterval(start, end);

            if (interval <= 100) {
              this.chartType = 'line';
              this.chartOption = this.getChartOption(this.manuRules);
            } else {
              this.chartType = 'candlestick';
            }
          }
        }

        const { start, end } = params;
        if (
          start !== '' &&
          start !== undefined &&
          end !== '' &&
          end !== undefined
        ) {
          // const diff = Math.abs(end - start);
          this.currentStart = start;
          this.currentEnd = end;

          const interval = this.getInterval(start, end);

          if (interval <= 100) {
            this.chartType = 'line';
            this.chartOption = this.getChartOption(this.manuRules);
          } else {
            this.chartType = 'candlestick';
          }
          // this.chartOption = this.getChartOption(this.manuRules);
        }
      }, 1000);
    },

    handleBrushChange(params) {
      const { areas } = params;
      const { coordRange } = areas[0] || {};

      if (coordRange) {
        let [start, end] = coordRange;

        start = start < 0 ? 0 : start;

        end = end > this.timestamp.length - 1 ? this.timestamp.length - 1 : end;

        this.tableStartVal = this.timestamp[start];
        this.tableEndVal = this.timestamp[end];

        this.brushStart = start;
        this.brushEnd = end;

        if (this.timer) {
          clearTimeout(this.timer);
        }

        this.timer = setTimeout(() => {
          this.judgeGoToQuery(false, true);
        }, 1000);
      }
    },
    handleDateChange() {},
    handleTabItemClick(index) {
      this.activeTab = index;
    },
    handleDelClick(item) {
      const { id } = item;

      this.$postForm('/winddata/dataRuleMark/deleteTowerRule', {
        module: 'windData',
        showError: true,
        showSuccess: true,
        data: {
          towerRuleId: id
        }
      }).then(() => {
        this.queryTowerRuleList();
      });
    },
    handlePlusClick() {
      this.dialogTitle = '添加规则标记';
      this.dialogVisible = true;
    },
    handleApplyRule() {
      const rules = this.rules.filter(i => i.checked).map(i => i.id);

      if (!rules.length) return this.$message.warning('请选择至少一条规则');

      this.$fetch('/winddata/dataRuleMark/checkRule', {
        params: {
          versionId: this.SelectVersionId,
          towerRuleIds: rules.join(',')
        },
        module: 'windData',
        showError: true,
        showSuccess: true,
        showLoading: true
      }).then(() => {
        const channels = this.checkedChannels().join(',');

        // if (this.isShowChart) {
        this.queryErrorData(channels, false).then(data => {
          data.forEach(i => {
            const { name, errorData } = i;

            const newArr = this.manuRules.map(
              rule => `${rule.channelNo}_${rule.type}`
            );

            const findIndex = newArr.findIndex(a => a == name);

            if (findIndex !== undefined) {
              // this.manuRules[findIndex]._data = data;
              this.manuRules[findIndex]._errorData = errorData;
            }
          });
          this.chartOption = this.getChartOption(this.manuRules);

          this.hasTableFlag = false;
        });
        // }
      });
    },
    handleRuleItemClick(item) {
      this.dialogTitle = '编辑规则标记';
      this.dialogVisible = true;
      this.towerRuleId = item.towerRuleId;
      this.ruleForm = {
        ruleName: item.ruleName,
        dataRuleId: item.dataRuleId,
        checkRuleId: item.checkRuleId,
        stepType: item.stepType,
        stepValue: item.stepValue
        // channelType: +item.channelType
      };

      this.markState = item.state;
      const markChannels = item.applicationChannelNo.split(',');
      this.channels.forEach(i => {
        if (markChannels.includes('' + i.channelNo)) {
          i._applyChecked = true;
        }
      });

      if ([5, 4].includes(item.checkRuleId)) {
        this.isOneInput = false;
      } else {
        this.isOneInput = true;
      }

      if ([1, 2].includes(item.dataRuleId)) {
        this.isOneChannel = true;
      } else {
        this.isOneChannel = false;
      }

      this.queryCheckRules(item.dataRuleId);

      const channelIds = item.channelId.split(',').map(i => +i);
      const channelTypes = item.channelType.split(',').map(i => +i);

      this.channelStore = {
        channelId1: channelTypes[0] + '_' + channelIds[0] || '',
        channelId2:
          (channelTypes[1] &&
            channelIds[1] &&
            channelTypes[1] + '_' + channelIds[1]) ||
          ''
      };

      const values = item.value.split(',').map(i => +i);
      this.inputStore = {
        num1: values[0],
        num2: values[1]
      };
    }
  }
};
</script>
<style lang="less" scoped>
.wind-stand-footer-container {
  span:last-child {
    margin-left: 10px;
  }
}
.place-text {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #222233;
}
.all-check-channel {
  display: flex;
}

.result-table-container {
  display: flex;
  font-size: 12px;
  color: #fff;
  width: 100%;

  .title {
    width: 70px;
    line-height: 28px;
    height: 28px;
    text-align: center;
    background-color: #0477a1;
  }

  .even {
    width: 70px;
    line-height: 28px;
    height: 28px;
    text-align: center;
    background-color: #1e608f;
  }
  .odd {
    width: 70px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background-color: #126e6d;
  }
  .left-pad {
    width: 70px;
  }
  .right-pad {
    display: flex;
    flex: 1;
    // justify-content: space-between;
  }
}

.tab-content-inner {
  width: 100%;
  position: relative;
  flex: 1;
}

.apply-box {
  width: 100%;
  text-align: right;
  box-sizing: border-box;
  padding: 5px;
  bottom: 0px;
  position: absolute;
  z-index: 1000;
  color: #fff;
  background-color: @brandColor;
  & > span {
    cursor: pointer;
  }
}

.init-shuaixuan {
  display: flex;
  justify-content: space-between;
  padding: 3px 0px;
}

.dialog-content {
  .name {
    width: 300px;
    display: flex;
    align-items: center;
    .key-name {
      margin-right: 10px;
      text-align: right;
      min-width: 70px;
    }
  }
  .apply-channel {
    margin-top: 10px;
    align-items: center;

    display: flex;
    .key-name {
      margin-right: 10px;
      text-align: right;
      min-width: 70px;
    }
    .el-radio__label {
      font-size: 12px;
    }
  }
  .logic {
    margin-top: 10px;
    display: flex;
    align-items: center;
    .key-name {
      margin-right: 10px;
      text-align: right;
      min-width: 70px;
    }
  }

  .value-box {
    display: flex;
    align-items: center;
  }
}

.rationality-containear {
  .picker-box {
    display: flex;
    justify-content: space-between;
  }

  .tab-box {
    // flex: 1;
    // height: 100%;
    box-sizing: border-box;
    // padding-top: 20px;
    display: flex;
    position: relative;
    flex-direction: column;
    background: rgb(240, 245, 250);
    .tab-title {
      height: 28px;
      font-size: 0;
      border: 1px solid #0057aaff;
      display: flex;
      border-radius: 8px;
      align-items: center;
      overflow: hidden;
      line-height: 26px;
      box-sizing: border-box;
      margin: 10px;
      .tab-item {
        display: inline-block;
        font-size: 14px;
        color: #0057aaff;
        text-align: center;
        flex: 1;
        height: 100%;
        cursor: pointer;
        &.active {
          color: #fff;
          background: #0057aaff;
          background: linear-gradient(to right, #0878bfff 0%, #0056aaff 100%);
        }
      }
    }
    .tab-content {
      flex-direction: column;
      display: flex;
      position: relative;
      background-color: #333;
      // flex: 1;
      color: #fff;
      padding: 5px;
      max-height: 550px;
      padding-bottom: 40px;
      overflow: auto;

      .first-top,
      .last-top {
        width: 100%;
        flex: 1;
      }

      .first-bottom,
      .last-bottom {
        text-align: right;
        height: 30px;
        padding-right: 5px;
        padding-top: 10px;
        padding-bottom: 10px;
      }

      .first,
      .last {
        display: flex;
        flex-direction: column;
        .plus {
          height: 30px;
        }
        .rule-item {
          .color-tag {
            height: 4px;
            width: 10px;
            border-radius: 3px;
            background-color: #fff;
            margin-right: 10px;
          }
          cursor: pointer;
          &:hover {
            background-color: #003e8e;
          }
          padding: 0px 10px;
          height: 30px;
          display: flex;
          align-items: center;
          margin-bottom: 3px;
          .name {
            margin-left: 6px;
            // height: 100%;
            display: flex;
            flex: 1;
            flex-wrap: nowrap;
            align-items: center;
            white-space: pre-wrap;
            word-wrap: break-word;
            overflow: hidden;
          }
          position: relative;
          i {
            position: absolute;
            right: 3px;
            cursor: pointer;
          }
        }
        .plus {
          position: relative;
          i {
            font-size: 16px;
            position: absolute;
            right: 7px;
            top: 50%;
            cursor: pointer;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  .main-pad {
    height: 100%;
    display: flex;
  }
  font-size: 12px;
  color: #222233;
  background-color: #fff;
  height: 100%;
  display: z flex;
  flex-direction: column;
  padding: 20px;

  .table {
    flex: 2;
    margin-top: 10px;
  }

  .chart-table {
    margin-right: 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .chart-box {
    position: relative;
    .tool-btn {
      position: absolute;
      top: -3px;
      right: 35px;
      z-index: 2000;

      &.sp {
        top: 20px;
      }
    }
    // line-height: 400px;
    text-align: center;
    color: #fff;
    // height: 400px;
    height: 280px;
  }

  .tool-box {
    display: flex;
    flex-direction: column;
    width: 200px;
  }
}

.btn {
  display: inline-block;
  color: #fff;
  cursor: pointer;
  margin-left: 10px;
}
.dialog-content {
  font-size: 12px;
  // color: #fff;
  // padding: 10px;
}
</style>

<style lang="less">
#hot-display-license-info {
  display: none !important;
}
.htContextMenu table tbody tr td {
  padding: 2px 0px;
}

.rationality-containear {
  box-sizing: border-box;
  .checkbox-width {
    display: flex;
    flex-wrap: wrap;
    .el-checkbox {
      width: 100px;
    }
  }
  .el-input {
    height: 26px;
    line-height: 16px;
    .el-input__inner {
      padding: 0px;
    }
    input {
      outline: none;
      height: 26px;
      background-color: transparent;
      border-color: transparent;
      border: none;
      border-bottom: 1px solid #606266;
      color: #606266;
      border-radius: 0px;
      box-sizing: border-box;
    }
  }
}
</style>

<style lang="less">
.rationality-containear {
  .my-hot {
    & > .handsontable {
      background-color: #ddd;
    }
  }

  .my-hot-table-class {
    tbody {
      text-align: center;
    }
  }

  .logic {
    .el-input {
      input {
        text-align: center;
      }
    }
    .el-select {
      width: 100%;
    }
  }
}

.all-check-channel {
  .el-checkbox {
    .el-checkbox__label {
      // color: #fff;
      font-size: 12px;
    }
  }
}
.apply-channel {
  .el-radio__label {
    font-size: 12px;
  }
}
</style>
